import { string } from 'yup';

export const requiredStringValidation = (field = 'Field') =>
  string().nullable().required(`${field} is required`);
export const optionalStringValidation = string().optional().nullable();

export const nameValidation = (person?: string, name?: string) =>
  requiredStringValidation(`${person || ''}${name || ''} Name`);
